import React, { Component } from "react";
import { injectIntl, FormattedMessage } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import TagV2 from "../tagV2/TagV2";
// import UploadFile from './UploadFile'
import UploadFilesV2 from "./UploadFilesV2";
import Copyright from "./Copyright";
import Breadcrumb from "../breadcrumb/Breadcrumb";
import { Form, Button, Icon, Popconfirm /*, Alert*/ } from "antd";
import { getExplore } from "../../actions/AssetsExploreAction";
import {
  getRoot,
  cleanDataBackRoot
} from "../../actions/AssetsRootAction";
import { refrescarHastaQueCrezca } from "../../utils";
import store from "../../store";
import { getLastUploads } from "../../actions/AssetsLastUploadAction";
import {
  setUploading,
  unsetUploading,
  setQtyFilesError,
  handleUserAttemps,
  setNumberAttemps
} from "../../actions/ClientAction";
import moment from "moment";
import { sendNotification, getNewPermission } from "../../utils/index";
import { RIGHTS_STATUS_UNASSIGNED } from "../../constants/rights-constants";
import { getGroupByClientIdUserId } from "../../actions/GroupAction";
import {
  getStorageHistory,
  getFolderSpace,
  getAssetsList
} from "../../actions/StorageAction";

export class CreateAsset extends Component {
  constructor(props) {
    super(props);

    this.state = {
      folderId: null,
      tags: [],
      copyright: {
        rightsStatus: RIGHTS_STATUS_UNASSIGNED,
        createDate: moment().format("YYYY-MM-DD"),
        dueDate: null
      },
      fileListCount: 0,
      start: false,
      emptyFields: false,
      isMultiple: false,
      tagProtocol: "",
      showProtocolAlert: null,
      showWarningEmptyTags: false
    };
  }

  componentDidMount() {
    const { folderselect, breadcrumbs } = this.props;

    this.setState({
      folderId: folderselect
    });

    if (folderselect) {
      const breadcrumb = breadcrumbs.find(a => a._id === folderselect);
      this.setState({
        showProtocolAlert:
          breadcrumb && breadcrumb.parents && breadcrumb.parents.length > 1
            ? true
            : false,
        tagProtocol: breadcrumb ? breadcrumb.tagProtocol : ""
      });
    }
  }

  // Mismo criterio que el modal de carpetas: el backend puede tardar en crear
  // los objetos, asi que reintentamos con espera creciente hasta que el conteo
  // crezca, y cortamos si el usuario se fue a otra carpeta.
  //
  // A proposito no cancelamos los reintentos al desmontar: este componente vive
  // dentro de un Modal con destroyOnClose, y se destruye justo cuando termina la
  // subida. Cancelar ahi dejaria la grilla sin actualizar, que es precisamente
  // el problema que estamos arreglando. Los reintentos son acotados (5 como
  // maximo) y solo despachan acciones y leen el store, asi que son inocuos
  // despues del desmontaje.
  refrescarVistaActual = (workclient, root) => {
    const carpetaActual = () => this.props.location.pathname.split("/").pop();
    const exploreId = carpetaActual();
    const enRaiz = exploreId === "home";

    if (enRaiz) {
      this.props.cleanDataBackRoot();
    }

    if (this.cancelarRefresco) this.cancelarRefresco();
    this.cancelarRefresco = refrescarHastaQueCrezca(
      () =>
        enRaiz
          ? this.props.getRoot(workclient, root, true, [], 1, 40)
          : this.props.getExplore(
              workclient,
              exploreId,
              1,
              undefined,
              undefined,
              undefined,
              20
            ),
      () => {
        const slice = enRaiz
          ? store.getState().assetsRoot
          : store.getState().assetsExplore;
        return ((slice && slice.data) || []).length;
      },
      () => carpetaActual() !== exploreId
    );
  };

  componentDidUpdate(prevProps) {
    const { folderselect } = this.props;
    const { start } = this.state;

    if (!start && prevProps.folderselect !== folderselect) {
      this.setState({
        folderId: folderselect
      });
    }
  }

  handleFolderSelect = folderId => {
    const { breadcrumbs } = this.props;
    const breadcrumb = breadcrumbs.find(a => a._id === folderId);

    this.setState({
      folderId,
      showProtocolAlert:
        breadcrumb && breadcrumb.parents && breadcrumb.parents.length > 1
          ? true
          : false,
      tagProtocol: breadcrumb ? breadcrumb.tagProtocol : ""
    });
  };

  handleTags = objectTag => {
    this.setState({
      tags: objectTag.tags,
      showWarningEmptyTags: objectTag.tags && objectTag.tags.length === 0
    });
  };

  handleCopyright = copyright => {
    this.setState({ copyright: copyright.copyright });
  };

  handleValidateCreateAsset = () => {
    const { folderId, tags, fileListCount } = this.state;
    const { intl } = this.props;

    if (folderId === null) {
      sendNotification(
        "warning",
        intl,
        intl.formatMessage({ id: "select_valid_destination" })
      );
      return;
    }

    if (fileListCount === 0) {
      sendNotification(
        "warning",
        intl,
        intl.formatMessage({ id: "select_upload_destination" })
      );
      this.setState({
        start: false
      });
      return;
    }

    if (tags && tags.length === 0) {
      this.setState({
        showWarningEmptyTags: true
      });
    } else {
      this.handleCreateAsset();
    }
  };

  handleCreateAsset = () => {
    const { folderId } = this.state;
    const { folderselect, workclient, intl, newMatrix, user } = this.props;

    const canUploadAssetInFolder =
      user.clientRole !== "admin"
        ? getNewPermission(folderId, newMatrix, "upload")
        : true;
    if (canUploadAssetInFolder) {
      this.props.setUploading(workclient, folderselect);
      this.setState({
        start: true
      });
    } else {
      sendNotification(
        "warning",
        intl,
        intl.formatMessage({ id: "permission_denied" })
      );
    }
  };

  handleIsDone = showMessage => {
    const { folderselect, workclient, root, qtyFilesError, intl } = this.props;
    this.setState(
      {
        start: false,
        emptyFields: true
      },
      () => {
        setTimeout(() => {
          if (qtyFilesError === 0) {
            this.props.handleHideCreateAsset();
            this.props.unsetUploading();
          }
          this.props.getFolderSpace(workclient);
          this.props.getGroupByClientIdUserId(workclient);
          this.props.getLastUploads(workclient, root);
          this.props.getAssetsList(workclient, intl);
          this.props.getStorageHistory(workclient);
          // La grilla de la carpeta no se refrescaba nunca aca: getExplore
          // estaba importado y conectado, pero no se llamaba, asi que habia
          // que recargar la pagina para ver el archivo subido. DES-196.
          this.refrescarVistaActual(workclient, root);
        }, 500);
        this.props.setUploading(workclient, folderselect);
      }
    );
    // if (showMessage) sendNotification('info', intl, intl.formatMessage({ id: 'been_successfully_uploaded' }), 3, 'topRight')
  };

  handleError = () => {
    this.setState(
      {
        start: false
      },
      () => this.props.unsetUploading()
    );
  };

  handleOnClose = () => {
    this.props.setQtyFilesError(0);
    this.props.handleUserAttemps([]);
    this.props.setNumberAttemps(0);
    this.setState(
      {
        start: false,
        showProtocolAlert: false,
        fileListCount: 0,
        emptyFields: false
      },
      () => {
        this.setState(
          {
            emptyFields: true
          },
          () => {
            setTimeout(() => {
              this.props.handleHideCreateAsset();
              this.props.unsetUploading();
            }, 400);
          }
        );
      }
    );
  };

  handleGetFileListTotal = count => {
    const { tags, folderId } = this.state;

    this.setState({
      fileListCount: count,
      showWarningEmptyTags: folderId && tags && tags.length === 0
    });
  };

  render() {
    const {
      intl,
      newColor,
      qtyFilesError,
      attemps,
      user,
      isUploading
    } = this.props;
    const {
      tags,
      copyright,
      folderId,
      start,
      emptyFields,
      tagProtocol,
      showProtocolAlert,
      isMultiple,
      fileListCount,
      showWarningEmptyTags
    } = this.state;

    const metadata = {
      tags,
      copyright,
      folderId
    };
    let startModified = fileListCount === qtyFilesError ? false : start;
    let styleUploadButton = {
      backgroundColor: newColor,
      borderColor: newColor
    };

    if (attemps.length > 0) {
      if (fileListCount !== qtyFilesError) {
        startModified = true;
      }
      Object.assign(styleUploadButton, { pointerEvents: "none", opacity: 0.5 });
    } else {
      if (qtyFilesError > 0) {
        Object.assign(styleUploadButton, {
          pointerEvents: "none",
          opacity: 0.5
        });
      } else {
        delete styleUploadButton.pointerEvents;
        delete styleUploadButton.opacity;
      }
    }

    return (
      <Form layout="vertical">
        {showProtocolAlert && (
          <Form.Item>
            <div
              style={{
                borderRadius: "5px",
                border: "1px solid #91d5ff",
                marginBottom: "13px",
                backgroundColor: "#e6f7ff"
              }}
            >
              <div
                style={{
                  margin: "12px 0 10px 15px",
                  display: "flex",
                  alignItems: "flex-start"
                }}
              >
                <Icon
                  type="info-circle"
                  theme="twoTone"
                  style={{ fontSize: "30px" }}
                />
                <h4 style={{ margin: "5px 0 0 10px" }}>
                  {intl.formatMessage({ id: "tags_protocol" })}
                </h4>
              </div>
              <div
                style={{ margin: "0 17px 10px 40px" }}
                dangerouslySetInnerHTML={{ __html: tagProtocol }}
              ></div>
            </div>
          </Form.Item>
        )}
        <Form.Item style={{ marginBottom: "10px" }}>
          <Breadcrumb
            title={intl.formatMessage({ id: "breadcrumb_select_folder" })}
            value={folderId}
            isMultiple={isMultiple}
            handleFolderSelect={this.handleFolderSelect}
            permissionAware={
              user.clientRole === "admin" || user.role === "admin"
                ? false
                : true
            }
            permissionsArray={["upload"]}
            placeholder={intl.formatMessage({ id: "breadcrumb_placeholder" })}
          />
        </Form.Item>
        <Form.Item style={{ marginBottom: "10px" }}>
          <span>{intl.formatMessage({ id: "add_tags" })}</span>
          <TagV2 fillTags={tags} handleTags={this.handleTags} />
        </Form.Item>
        <Form.Item style={{ marginBottom: "0" }}>
          {/* Punto 2 de Ricardo: el contrato de cesión se puede adjuntar desde
              la propia subida, no sólo después desde el Gestor. */}
          <Copyright handleCopyright={this.handleCopyright} allowLicenseFile />
        </Form.Item>
        <Form.Item>
          <UploadFilesV2
            theme={"light"}
            start={start}
            clear={emptyFields}
            itemSelected={null}
            metadata={metadata}
            isDone={this.handleIsDone}
            fileListTotal={this.handleGetFileListTotal}
            isAssetVersion={false}
            isMultiple={true}
            folderId={folderId}
            className="upload-filesV2"
            quitOrCancel={this.handleOnClose}
          />
        </Form.Item>

        {!showWarningEmptyTags && (
          <Button
            loading={startModified ? true : isUploading ? true : false}
            type="primary"
            style={styleUploadButton}
            onClick={this.handleValidateCreateAsset}
          >
            <FormattedMessage id="upload_button" />
            <Icon type="cloud-upload" />
          </Button>
        )}

        {showWarningEmptyTags && (
          <Popconfirm
            title={intl.formatMessage({ id: "tags_confirm_empty_tags" })}
            onConfirm={() => {
              this.setState(
                {
                  showWarningEmptyTags: false
                },
                () => this.handleCreateAsset()
              );
            }}
            okText={intl.formatMessage({ id: "tags_upload_without_tags" })}
            cancelText={intl.formatMessage({ id: "tags_upload_add_tags" })}
          >
            <Button
              loading={startModified ? true : isUploading ? true : false}
              type="primary"
              style={styleUploadButton}
            >
              <FormattedMessage id="upload_button" />
              <Icon type="cloud-upload" />
            </Button>
          </Popconfirm>
        )}

        <Button
          type="default"
          onClick={this.handleOnClose}
          style={{ marginLeft: 10, color: newColor, borderColor: newColor }}
        >
          {" "}
          <FormattedMessage id="cancel_button" />
          <Icon type="close" />
        </Button>
      </Form>
    );
  }
}

const mapStateToProps = state => {
  return {
    folderselect: state.assetsExplore.folderselect,
    newColor:
      state.authUser.user && state.authUser.user.color
        ? state.authUser.user.color
        : "#2E97CF",
    workclient: state.client.workclient,
    root: state.client.root,
    breadcrumbs: state.client.breadcrumb,
    qtyFilesError: state.client.qtyFilesError,
    attemps: state.client.attemps,
    user: state.authUser.user,
    newMatrix: state.group.newMatrix,
    isUploading: state.client.isUploading
  };
};

const mapDispatchToProps = {
  setUploading,
  unsetUploading,
  getExplore,
  getRoot,
  cleanDataBackRoot,
  getLastUploads,
  setQtyFilesError,
  handleUserAttemps,
  setNumberAttemps,
  getGroupByClientIdUserId,
  getFolderSpace,
  getStorageHistory,
  getAssetsList
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(CreateAsset))
);
